import React  from 'react';

export default function renderListGroupTListHeader2(id, props) {
    const customField = gd.session.customFields.get(id);
    const item = _.find(customField.params.listItems, i=>i.id === props.data.value);

    return <div className="text ui5-txt-default">{item ? item.value : "Not selected"}</div>;
}